/** PrismMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('prismmesh', ['PrismMesh']);
//# sourceMappingURL=index.js.map